import React from 'react';
import './AboutUs.css';

import { Banner, PageTitle } from '../../../components';
import { About, Testimonials, Counter, WhyUs, Team, Services, Clients, Mission, FAQs, Industries, Process, Awards } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About /> {/* Company overview */}
        <WhyUs /> {/* Key benefits */}
        <Services /> {/* Offered services */}
        <Counter /> {/* Stats & achievements */}
        <Process /> {/* Process Slider */}
        <Mission /> {/* Mission Section */}
        <FAQs /> {/* FAQs Section */}
        <Industries /> {/* Served industries */}
        <Team /> {/* Meet the team */}
        <Testimonials /> {/* Client feedback */}
        <Awards /> {/* Awards Section */}
        <Banner /> {/* Call-to-action Banner */}
        <Clients /> {/* Clients Slider */}

      </section>

    </>
  );
}

export default AboutUs;